import React, { useEffect, useState } from "react";
import Profile from "./Profile";
import {
  AppBar,
  IconButton,
  Toolbar,
  Button,
  Grid,
  Container,
  useMediaQuery,
  useTheme,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { AccountCircle, Group, Map, PersonAdd } from "@mui/icons-material";
import UserManagement from "./UserManagement";
import { SessionManager } from "../utils/consts";
import Dashboard from "./Demo/Dashboard";

interface HomeProps {
  sessionManager: SessionManager;
}

export interface Features {
  features: string[];
}

const Home: React.FC<HomeProps> = ({ sessionManager }) => {
  const [showProfile, setShowProfile] = useState(false);
  const [showUserManagement, setShowUserManagement] = useState(false);
  const [showUserBack, setShowUserBack] = useState(false);
  const [features, setFeatures] = useState<Features | null>(null);
  const [showDashboard, setShowDashboard] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  function resetAll() {
    setShowProfile(false);
    setShowUserManagement(false);
    setShowUserBack(false);
    setShowDashboard(false);
    getFeatures();
  }

  const getFeatures = async () => {
    const responseData = await sessionManager.getData("features");
    setFeatures(responseData);
  };

  useEffect(() => {
    getFeatures();
  }, []);

  return (
    <div>
      <AppBar position="fixed" style={{ zIndex: 1300 }}>
        <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
          {showUserBack ? (
            <Button
              color="inherit"
              style={{ left: 0, fontWeight: "bold" }}
              onClick={() => {
                setShowUserManagement(!showUserManagement);
                setShowUserBack(false);
                resetAll();
              }}
            >
              Back
            </Button>
          ) : (
            <div></div>
          )}
          <img
            src="/landcalc.png"
            alt="Land Calc"
            style={{ height: isMobile ? "50px" : "80px" }}
          />
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setShowProfile(!showProfile)}
            >
              <AccountCircle />
            </IconButton>
            <Button color="inherit" onClick={sessionManager.signOut}>
              Sign Out
            </Button>
          </div>
        </Toolbar>
      </AppBar>

      <Toolbar />

      {showProfile ? (
        <Profile sessionManager={sessionManager} />
      ) : showUserManagement ? (
        <UserManagement sessionManager={sessionManager} />
      ) : showDashboard ? (
        <Dashboard sessionManager={sessionManager} />
      ) : (
        <Container style={{ marginTop: "20px" }}>
          <Grid container spacing={2} justifyContent="center">
            {features?.features.includes("user_management") ? (
              <Grid item xs={12} sm={6} md={4}>
                <Button
                  variant="contained"
                  fullWidth
                  style={{
                    height: "300px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    setShowUserManagement(!showUserManagement);
                    setShowUserBack(true);
                  }}
                >
                  <Group style={{ fontSize: 100 }} />
                  User Management
                </Button>
              </Grid>
            ) : null}

            {features?.features.includes("demo") ? (
              <Grid item xs={12} sm={6} md={4}>
                <Button
                  variant="contained"
                  fullWidth
                  style={{
                    height: "300px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    setShowDashboard(!showDashboard);
                    setShowUserBack(true);
                  }}
                >
                  <Map style={{ fontSize: 100 }} />
                  Mount Penang Demo
                </Button>
              </Grid>
            ) : null}
            <Grid item xs={12} sm={6} md={4}>
              <Button
                variant="contained"
                fullWidth
                style={{
                  height: "300px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => {
                  setOpenDialog(true);
                }}
              >
                <PersonAdd style={{ fontSize: 100 }} />
                Become a Tester
                <p style={{ fontSize: "12px" }}>
                  Become a Tester and get access to our beta features
                </p>
              </Button>
            </Grid>
          </Grid>
        </Container>
      )}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Become a Tester</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Send us an email and we will get back to you
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Home;
